import { useQuery } from "@tanstack/react-query";

import { getInstallationMaterials } from "../api/filter";

export function useInstallationMaterials() {
  return useQuery<string[]>({
    queryKey: ["filter-options", "installation-materials"],
    queryFn: getInstallationMaterials,
    staleTime: 5 * 60 * 1000,
  });
}
